import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './login.css'
import { GRADIENTS } from 'utils/theme';
import { useToast } from 'components/ui/ToastContainer';
import LoadingSpinner from 'components/ui/LoadingSpinner';
import Cookies from 'js-cookie';
import Useaxios from 'utils/Useaxios';
import { useDispatch } from 'react-redux';
import { login } from '../../redux/AuthSlice';
import { setExchangeRate } from 'utils/currency';
import { setGlobalCurrency } from 'utils/currency';


const Login = () => {
    const [formData, setFormData] = useState({
        // email: 'admin.123@gmail.com',
        // password: 'admin@123'
        email: localStorage.getItem('userEmail') || '',
        password: ''
    });
    const dispatch = useDispatch()
    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const { email, password } = formData;
    const navigate = useNavigate();
    const { showSuccess, showError } = useToast();
    const { fetchData, loading } = Useaxios();

    // Load stored email on component mount
    React.useEffect(() => {
        const storedEmail = localStorage.getItem('userEmail');
        if (storedEmail && !formData.email) {
            setFormData(prev => ({ ...prev, email: storedEmail }));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));

        // Store email in localStorage for forgot password
        if (name === 'email') {
            localStorage.setItem('userEmail', value);
        }

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };


    const formValidation = () => {
        const newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formData.email)) {
            newErrors.email = 'Invalid email format';
        }

        if (!formData.password.trim()) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 6) {
            newErrors.password = 'Password must be at least 6 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formValidation()) return;

        try {
            const response = await fetchData({
                url: '/api/v1/admin/auth/login',
                method: 'post',
                data: {
                    email: formData.email,
                    password: formData.password
                }
            });

            if (response.success) {
                console.log(response)
                const user = response.data
                const token = response.data.token
                const exchangeRate = response.data.exchangeRate
                setExchangeRate(exchangeRate)
                // setGlobalCurrency('LRD')
                dispatch(login({ token, user }));
                // showSuccess('Login successful! Redirecting...', 3000);
                setTimeout(() => {
                    navigate('/admin/dashboard');
                }, 500);
            }
        } catch (error) {
            showError(error.response?.data?.message || 'Invalid email or password');
            setErrors({
                email: 'Invalid credentials',
                password: 'Invalid credentials'
            });
        }
    };

    return (
        <>
            <div
                className="auth-wrapper animated-background"
                style={{
                    background: 'linear-gradient(-45deg, #0d7a77, #159F9C, #1ab3af, #20c4c0)',
                    backgroundSize: '400% 400%',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >

                <div className="login-container">
                    <div className="glass-form form-entrance">
                        <div className=" " style={{
                            background:"transparent",
                            marginBottom:"20px",
                            marginTop:"20px",
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center"
                        }}>
                            <div className="logo-img">

                                <img src="https://api.vendispot231.online/uploads/logo.png"
                                    style={{ height: '60px', }}
                                />
                            </div>
                        </div>

                        <div className="login-header">
                            <h2>Welcome Back</h2>
                            <p>sign in to your account</p>
                        </div>

                        <form onSubmit={handleSubmit} className="login-form" autoComplete="off">
                            <div className="form-group" style={{ position: 'relative' }}>
                                <input
                                    className={`custom-input ${errors.email ? 'error-input' : ''}`}
                                    style={{
                                        width: '100%',
                                        // minWidth: "53vh",
                                        padding: "18px 18px",
                                        borderRadius: "8px",
                                        border: "none",
                                        outline: "none",
                                        height: "5vh",
                                    }}
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    placeholder="Email"
                                    autoComplete="off"
                                    autoFill="off"
                                />
                                <div className="input-focus-line"></div>
                                {errors.email && <span className="input-error">{errors.email}</span>}
                            </div>

                            <div className="form-group" style={{ position: 'relative' }}>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                    <input
                                        className={`custom-input ${errors.password ? 'error-input' : ''}`}
                                        style={{
                                            width: '100%',
                                            // minWidth: "53vh",
                                            padding: "18px 50px 18px 18px",
                                            borderRadius: "8px",
                                            border: "none",
                                            outline: "none",
                                            height: "5vh",
                                        }}
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Password"
                                        minLength="6"
                                        autoComplete="new-password"
                                        autoFill="off"
                                    />
                                    <span
                                        className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: GRADIENTS.primary,
                                            width: '40px',
                                            height: "100%",
                                            position: 'absolute',
                                            right: '-13px',
                                            top: '0',
                                            cursor: 'pointer',
                                            fontSize: '18px',
                                            color: 'white',
                                            borderRadius: '0 8px 8px 0',
                                            zIndex: 1
                                        }}
                                    >
                                        {showPassword ? '🙈' : '👁️'}
                                    </span>
                                </div>
                                <div className="input-focus-line"></div>
                                {errors.password && <span className="input-error">{errors.password}</span>}
                            </div>

                            <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                <button
                                    type="button"
                                    onClick={() => navigate('/forgot-password')}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#159F9C',
                                        cursor: 'pointer',
                                        textDecoration: 'underline',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}
                                >
                                    Forgot Password?
                                </button>
                            </div>

                            <button type="submit" className="login-button" disabled={loading}>
                                {loading ? (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <LoadingSpinner size="small" color="white" />
                                        <span>Signing In...</span>
                                    </div>
                                ) : (
                                    <span className="button-text">Sign In</span>
                                )}
                            </button>
                        </form>

                        <div className="copyright">
                            <p className="text-center mt-3 text-white small copyright">
                                © {new Date().getFullYear()} Vendi-spot
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;